import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';
import { SmartphoneDB } from '../../../../components/SmartphoneDB.jsx';
import { RouterDB } from '../../../../components/RouterDB.jsx';

export function HardwareGridRender({ node, isLiveMode }) {
  const content = node.content || {};
  const type = content.type || 'smartphones';

  return (
    <div style={{ pointerEvents: !isLiveMode ? 'none' : 'auto', width: '100%' }}>
      {type === 'smartphones' ? <SmartphoneDB /> : <RouterDB />}
    </div>
  );
}

registry.register('HardwareGrid', {
  label: 'Hardware Datenbank',
  icon: '📱', 
  category: 'tef',
  component: HardwareGridRender,
  
  defaultProps: {
    content: {
      type: 'smartphones'
    },
    style: {
      desktop: {
        padding: '20px 0'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Einstellungen',
          fields: [
            { name: 'content.type', label: 'Hardware-Typ anzeigen', type: 'select', options: [
              { value: 'smartphones', label: 'Smartphones / Handys' },
              { value: 'routers', label: 'Router / Festnetz' }
            ]}
          ]
        }
      ]
    }
  ]
});
